import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './plugins/store';
import VueSocketIO from 'vue-socket.io';
import { io } from 'socket.io-client';
import Toast from 'vue-toastification';
import "vue-toastification/dist/index.css";
import VueApexCharts from 'vue-apexcharts'
import {mapState, mapGetters} from "vuex";

// import * as Sentry from "@sentry/vue";
// import { BrowserTracing } from "@sentry/tracing";

Vue.config.productionTip = false


// function getSocketIOUrl() {
//   // return undefined;
//   var getUrl = window.location;
//   let port = 8051 + (Math.round(Math.random()*5));

//   let baseHost = getUrl.host.split(":")[0];
//   var baseUrl = 'http://' + baseHost + ":" + port;

//   if (baseUrl.indexOf("monitor-app") < 0) {
//     return undefined;
//   }

//   console.log("Connecting socketIO to:", baseUrl);
//   return baseUrl;
// }

// function getSioKey() {
//   let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
//   let n = chars.length;
//   let key = '';
//   for (let i = 0; i < 10; i++) {
//     key += chars.charAt(Math.random() * n);
//   }
//   return key
// }

// Sentry.init({
//   Vue,
//   dsn: "https://c3bfb6a4098447acb28efa33ef44ecc5@o1211366.ingest.sentry.io/4504686140522496",
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracePropagationTargets: ["localhost", "monitor-app.zapto.org", /^\//],
//     }),
//   ],
//   tracesSampleRate: 0.01,
// });

Vue.use(new VueSocketIO({
  debug: false,
  connection: io(),
  vuex: {
    store,
    mutationPrefix: 'SOCKET_'
  }
}));

Vue.use(
  Toast,
  {
    transition: 'Vue-Toastification_bounce',
    maxToasts: 20,
    newestOnTop: true
  }
);

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

const app = new Vue({
  vuetify,
  router,
  store,
  data() {
    return {
      accountsInterval: null,

      nConnects: 0,

      disconnectedMs: null,
    }
  },
  computed: {
    ...mapState([
      'userInactive',
      'subscribedChannels',
    ]),
    ...mapGetters([
        'isAuthenticated',
    ]),
  },
  sockets: {
    disconnect() {
      this.$store.commit('setIsDisconnected', true);

      if (this.disconnectedMs === null) {
        // mark when we were last disconnected, so we can recover correctly
        this.disconnectedMs = Date.now();
        console.log("We disconnected for the first time since last connection")
      } else {
        console.log("?? we disconnected and were already disconnected ??")
      }
    },

    connect() {
      this.$store.commit('setIsDisconnected', false);

      // say hello, send if we had been disconnected
      let disconnected = false, disconnectedSecs = 0;

      if (this.disconnectedMs !== null) {
        disconnected = true;
        let nowMs = Date.now();
        disconnectedSecs = (nowMs - this.disconnectedMs) / 1000;
        console.log("We were disconnected for this many seconds, will recover:", disconnectedSecs);
        this.disconnectedMs = null;  // reset for next time
      }

      console.log("Connected!");

      // clear existing pings
      this.$store.dispatch('resetPings');

      // track connection count
      this.nConnects += 1;

      this.$socket.emit("hello", {
        msg: "hi from webapp!",
        disconnected: disconnected,
        disconnectedSecs: disconnectedSecs,
        channels: this.subscribedChannels,
      });

      // update pending messages
      // wait 2 seconds before setting failed
      setTimeout(() => {
        for (let displayID of Object.keys(this.$store.state.pendingMessages)) {
          let messages = [...this.$store.state.pendingMessages[displayID]];
          // set all messages to failed, we reconnected and didn't received the messages
          messages = messages.map(m => {
            m.failed = true;
            return m;
          })

          // update this acc pending messages
          this.$store.state.pendingMessages[displayID] = messages;
        }

        // force update
        this.$store.state.pendingMessages = {...this.$store.state.pendingMessages}
      }, 2000);

      if (!this.accountsInterval) {
        // only get club accounts now on first reconnect, otherwise the interval will
        // still be getting them
        this.$store.dispatch('getClubAccounts');

        // set up the interval
        this.accountsInterval = setInterval(() => {
          app.$store.dispatch('getClubAccounts');

          // * get codes
          let codes = [];
          for (let code in app.$store.getters.opponents) {
            codes.push(code);

            // batch these
            if (codes.length >= 20) {
              app.$store.dispatch('getOpponents', codes);
              codes = [];
            }
          }

          if (codes.length > 0) {
            app.$store.dispatch('getOpponents', codes);
          }
        }, 5 * 60 * 1000);
      }
    }
  },
  methods: {
    needToLoad() {
      const notShow = this.isSMSPage() || this.isTelegramPage() || this.isQuestionsPage() || this.isPokerTablePage() || this.isNotificationsPage() || this.isChatHistoryPage();
      return !notShow;
    },
    isChatHistoryPage() {
      return this.$route.name === "ChatHistory";
    },
    isTelegramPage() {
      return this.$route.name === "Telegram";
    },
    isQuestionsPage() {
      return this.$route.name === "Questions";
    },
    isPokerTablePage() {
      return this.$route.name === "Table";
    },
    isNotificationsPage() {
      return this.$route.name === "Notifications";
    },
    isSMSPage() {
      return this.$route.name === "SMS";
    },
  },
  render: h => h(App),
  created: function () {
    console.log("main Vue inst created!");


    // tick interval so can do period checks:
    // - cache recalculations
    // - ping checks
    setInterval(() => {
      this.$store.dispatch('ms100Ticked');
    }, 100);
  },
}).$mount('#app');
